import React, { useState } from 'react'
import _assign from 'lodash/assign'
import {
  Password as PasswordInput,
} from '../../FormInput.v2/index'
import { getPasswordValidation, PASSWORD_INPUT_MAX_CHARS } from '../../../services/password/index'

export default function ChangePassword (props) {
  const { staticText } = props
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')

  return (
    <div className="account-profile__form--change-password">
      <PasswordInput
        name="password"
        label={staticText.getIn(['data', 'currentPassword'])}
        formPasswordLabelClassName={['account-profile__form-label__edit', 'edit-label']}
        maxLength={PASSWORD_INPUT_MAX_CHARS}
        validations={{ minLength: 1 }}
        required
        value={currentPassword}
        onChange={(v) => setCurrentPassword(v)}
      />
      <br />
      <PasswordInput
        name="newPassword"
        label={staticText.getIn(['data', 'newPassword'])}
        formPasswordLabelClassName={['account-profile__form-label__edit', 'edit-label']}
        maxLength={PASSWORD_INPUT_MAX_CHARS}
        validations={_assign(
          getPasswordValidation(),
        )}
        validationErrors={{
          minLength: staticText.getIn(['data', 'passwordMinLengthMessage']),
          matchRegexp: staticText.getIn(['data', 'passwordRegexMessage']),
          maxLength: staticText.getIn(['data', 'passwordMaxLengthMessage']),
        }}
        required
        hasValidation
        value={newPassword}
        onChange={(v) => setNewPassword(v)}
        showStrength
      />
      <br />
      <PasswordInput
        name="passwordConfirm"
        label={staticText.getIn(['data', 'confirmNewPassword'])}
        formPasswordLabelClassName={['account-profile__form-label__edit', 'edit-label']}
        maxLength={PASSWORD_INPUT_MAX_CHARS}
        validations={_assign(
          { equalsField: 'newPassword' },
          getPasswordValidation(),
        )}
        validationErrors={{
          equalsField: staticText.getIn(['data', 'noMatch']),
        }}
        required
        hasValidation
        value={confirmNewPassword}
        onChange={(v) => setConfirmNewPassword(v)}
      />
    </div>
  )
}
